module.exports = __webpack_public_path__ + "img/infaq.90d8d6e2.svg";